import React from 'react';
import { LoaderBox, LoaderImage } from './styled';

export function ShowLoader() {
  return (
    <LoaderBox className="box">
      <LoaderImage src="/images/loader_gif.gif" alt="" />
    </LoaderBox>
  );
}
